
import Footer from "./footer";
import Header from "./header";

export default function Layout({children}) {
    return <div className="app-layout" style={{height: '100%'}}>
        {children}
    </div>
}